import { Directive, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';


/**------------------------------------------------------
 * Transform Router Link
 * ---------------------
 * Route routerLink url using router
 *
 * Theoretical Example:
 * If we need to pass a link in innerHtml in this case we
 * cannot router url in inner html. This directive will
 * find the routerLink attribute and use the injected
 * router instance to navigate to the route.
 *
 * Example:
 * --------
 * 	<div [innerHtml]="htmlDescHavingRouterLink" ngRouterLinkTransformer></div>
 */
@Directive({
    selector: '[ngRouterLinkTransformer]',
    standalone: false
})
export class NgRouterLinkTransformerDirective {

	constructor(
		private router			: Router,
		private activatedRoute	: ActivatedRoute
	) {}

	@HostListener('click', ['$event'])
	public onClick(event: Event): void {

		//0 - get route url
		const routeUrl: string = (event.target as HTMLElement).getAttribute('routerLink')!;
		if (!routeUrl) return;

		//1 - route to the url
		this.router.navigate([routeUrl], { relativeTo: this.activatedRoute });
		event.preventDefault();
	}
}
